import { Pipe, PipeTransform } from "@angular/core";
import SkillRating, {
  skillRatingToString,
  skillRatingValues,
} from "@skills-app/models/skillRating";

@Pipe({
  standalone: false,
  name: "orderSkillsByProficiencyThenName",
  pure: true,
})
export class OrderSkillsByProficiencyThenNamePipe implements PipeTransform {
  transform<T extends { SkillRating: SkillRating; Name: string }>(
    skills: T[] | null | undefined,
  ): T[] {
    if (!Array.isArray(skills)) {
      return [];
    }

    // Keep prior behaviour: derive a stable ordering from the presentation list
    const ratingDescriptions = skillRatingValues().map((v) => v.description);

    const ratingIndex = (rating: SkillRating): number => {
      const desc = skillRatingToString(rating);
      const idx = ratingDescriptions.indexOf(desc);
      return idx === -1 ? -1 : idx;
    };

    return skills.slice().sort((a, b) => {
      const aIdx = ratingIndex(a.SkillRating);
      const bIdx = ratingIndex(b.SkillRating);

      // higher first
      if (aIdx !== bIdx) return bIdx - aIdx;

      return a.Name.localeCompare(b.Name);
    });
  }
}
